var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-setting"},[_c('div',{staticClass:"v-setting__label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_c('div',{staticClass:"v-setting__input"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }